var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "filters" }, [
    _c("div", { staticClass: "service-status-container" }, [
      _c("div", { staticClass: "label" }, [
        _vm._v(_vm._s(_vm.$t("components.service.select_status")))
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "service-status" },
        _vm._l(_vm.serviceStatus, function(status, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "status",
              class: { selected: _vm.inSelected(status) },
              on: {
                click: function($event) {
                  return _vm.selectStatus(status, index)
                }
              }
            },
            [
              _c("span", [
                _vm._v("\n\t\t\t\t\t" + _vm._s(status.label) + "\n\t\t\t\t")
              ])
            ]
          )
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-287eb0f8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-287eb0f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/subscription/ServiceFilters.vue
// module id = siUF
// module chunks = 1